import cn from "classnames"

import { Card, Descriptions } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./OverviewCardTemplate.module.scss"

import type { OverviewCardTemplateComponent } from "."

export const EMPTY_VALUE = "-"

export const OverviewCardTemplate: OverviewCardTemplateComponent = ({
  items,
  title,
  subtitle,
  children,
  classes = {},
  column = 1
}) => (
  <Card
    className={cn(
      styles.card,
      classes.card,
      column === 2 && styles.rowDirection
    )}
    classNames={classes}
    title={<Heading level={5} title={title} classes={classes} />}
  >
    {subtitle}
    {!children && <Descriptions flex layout="horizontal" items={items} />}
    {children}
  </Card>
)
